import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box } from 'grommet/components/Box';
import { Text } from 'grommet/components/Text';
import { TextInput } from 'grommet/components/TextInput';
import { Button } from 'grommet/components/Button';
import AccessibleSelect from '../Components/AccessibleSelect';
/*import { css } from '@emotion/core';*/
import ReactTable from "react-table";
import InfoTable from './../Components/InfoTable';
import ReactExport from "react-data-export";
import data from '../Data.json';
import { GetTransactionListCtrl } from '../Controllers/Transaction/GetTransactionListCtrl';
import { GetTotalTransactionCtrl } from '../Controllers/Transaction/GetTotalTransactionCtrl';
import ModalErrorTimeout from '../Components/ModalErrorTimeout';
import ModalError from '../Components/ModalError';
import { /*logout,*/ loader, formatAmount } from '../Utils/Utility';


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Movimenti extends Component {
    static propTypes = {
        match: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    }
    constructor(props) {
        super(props);
        this.state = {
            data: data,
            search: '',
            minamount: '',
            maxamount: '',
            minamountnet: '',
            maxamountnet: '',
            selectedYearMonth: '',
            selectedDay: '',
            selectedMov: '',
            selectLabel:'',
            selected: {},
            showresult: false,
            value: [],
            months: [],
            numericMonths: [],
            monthsRequest: "",
            isLeapYear: false,
            LeapYear: '',
            monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
            optionsDay: [],
            selectedMonthYear: '',
            disabledSDays: true,
            dataHeader: {},
            dataTable: [],
            datas: [],
            codesoc: "",
            codpos: sessionStorage.getItem("codSocietario") === '0' ? "" : sessionStorage.getItem("codepos"),
            codepv: sessionStorage.getItem("codSocietario") === '0' ? "" : sessionStorage.getItem("code") ? sessionStorage.getItem("code") : '',
            tableMovimenti: [],
            pagina: 1,
            showTimeoutModal: false,
            showModalError: false,
            loadList: true,
            loadTotal: true,
            loadingExcel: false,
            isRicerca: false,
            pages: 0,
            currentPage: 1

        }
        this.setAmount = this.setAmount.bind(this);
        this.setSelectionMonthYear = this.setSelectionMonthYear.bind(this);
        this.setSelectionDay = this.setSelectionDay.bind(this);
        this.setSelectionMovements = this.setSelectionMovements.bind(this);
        this.showResult = this.showResult.bind(this);
        this.search = this.search.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.goToPage = this.goToPage.bind(this);
        this.downloadExcel = this.downloadExcel.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    setPoint(i) {
        const newSelected = this.state.selected;
        const newValue = this.state.value;
        newSelected[i] = !this.state.selected[i];
        newValue[i] = [i];

        this.setState({
            selected: newSelected,
            value: newValue
        })
    }

    setAmount(event) {
        var value = event.target.value !== undefined ? event.target.value : '';
        var regexNumb = /^[0-9]+$/;
        value = regexNumb.test(value) ? value : value.replace(/[^0-9]+/g, "");
        if (event.target.id === 'minamount') {
            this.setState({
                minamount: value
            })
        } else if (event.target.id === 'maxamount') {
            this.setState({
                maxamount: value
            })
        } else if (event.target.id === 'minamountnet') {
            this.setState({
                minamountnet: value
            })
        } else if (event.target.id === 'maxamountnet') {
            this.setState({
                maxamountnet: value
            })
        } else if (event.target.id === 'codpos') {
            this.setState({
                codpos: value
            })
        }
    }

    componentWillMount() {
        this.setDates();
        this.isLeapYear();
    }

    setDates() {
        var date = new Date();
        var numericMonths = [],
            months = [];
        var monthNames = this.state.monthNames;
        for (var i = 0; i < 13; i++) {
            var calMonth = 1 + date.getMonth()
            var tempMonth = calMonth < 10 ? '0' + calMonth : calMonth


            months.push(monthNames[date.getMonth()] + ' ' + date.getFullYear());
        
            numericMonths.push(date.getFullYear() + '' + tempMonth);
            date.setMonth(date.getMonth() - 1);

        }
        return this.setState({ months, numericMonths })
    }

    isLeapYear() {
        const year = new Date().getFullYear()
        const isLeap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);

        return isLeap
    }


    setSelectionMonthYear(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        
        // Se non c'è valore selezionato, resetta lo stato
        if (!selectedValue) {
            return this.setState({
                selectedYearMonth: '',
                selectedMonthYear: '',
                optionsDay: [],
                disabledSDays: true
            });
        }
        
        const selectedIndex = this.state.months.findIndex(month => month === selectedValue);
        var val = selectedIndex >= 0 ? this.state.numericMonths[selectedIndex] : '';
        
        // Popola i giorni in base al mese selezionato
        var days = [];
        var selectedMonthText = selectedValue.split(' ')[0];
        var selectedYear = selectedValue.split(' ')[1];
        var monthIndex = this.state.monthNames.indexOf(selectedMonthText);
        
        if (monthIndex >= 0 && selectedYear) {
            var daysInMonth = new Date(parseInt(selectedYear), monthIndex + 1, 0).getDate();
            for (var i = 1; i <= daysInMonth; i++) {
                days.push(i < 10 ? '0' + i : i.toString());
            }
        }
        
        this.setState({
            selectedYearMonth: selectedValue,
            selectedMonthYear: val,
            optionsDay: days,
            disabledSDays: false
        })
    }

    setSelectionDay(event) {
        // Estrae il valore dall'oggetto dell'opzione selezionata
        const selectedValue = event.option ? event.option.value : '';
        
        this.setState({
            selectedDay: selectedValue
        })
    }

    setSelectionMovements(event) {
        this.setState({
            selectLabel: event.value,
            selectedMov: this.setValueMovements(event.value)
        })
    }

    setValueMovements(value) {
        if(value === "Tutti"){
            return ''    
        } else if(value === "Solo Validi"){
            return 'V'
        } else {
            return 'A'
        }
    }

    showResult() {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        const {history} = this.props;

        if (this.state.selectedYearMonth !== '') {
            this.setState({
                isRicerca: true
            })
            GetTotalTransactionCtrl(function (data) {
                // Gestione risposta 204 (No Content) o dati vuoti
                const headerData = (data === '' || !data || Object.keys(data).length === 0) 
                    ? { count: 0, amount: 0, commission: 0, net: 0 }
                    : data;
                    
                self.setState({
                    dataHeader: headerData,
                    pages: Math.ceil(headerData.count / 60)
                }, function() {
                    this.resultPage();
                });
            }, function (error) {
                if(error === 401 || error === 408){
                    self.setState({
                        showTimeoutModal: true
                    })
                } else if(error === 500 || error === 404 || error === 403){
                    history.push({
                        pathname: '/ErrorPage'
                    });
                }

            }, this.state, token, ids);

        }
    }

    resultPage(typeCall) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        const {history} = this.props;
        
        this.setState({
            isRicerca: true
        })
       
        GetTransactionListCtrl(function (data) {
            self.setState({
                dataTable: data === '' ? [] : (Array.isArray(data) ? data : []),
                isRicerca: false,
                showresult: true
            });
        }, function (error) {
            if(error === 401 || error === 408){
                self.setState({
                    showTimeoutModal: true
                })
            } else {
                history.push({
                    pathname: '/ErrorPage'
                });
            }
        }, this.state, typeCall, token, ids);
    }

    downloadExcel(typeCall) {
        var token = sessionStorage.getItem('token')
        var ids = sessionStorage.getItem('ids')
        const self = this;
        const {history} = this.props;
        this.setState({
          loadingExcel: true
        })
        GetTransactionListCtrl(function (data) {
            self.setState({
              datas: data === '' || !Array.isArray(data) ? [] : data,
              loadingExcel: false
            });
            document.getElementById('excel').click();
          }, function (error) {
                if(error === 401 || error === 408){
                    self.setState({
                        showTimeoutModal: true
                    })
                } else {
                    history.push('/ErrorPage');
                }
            }, this.state, typeCall, token, ids);
      }

    search(){
        this.setState({
            currentPage: 1,
            pages: 0,
            dataHeader: {},
            dataTable: [],
        }, () => {
            this.showResult();
        });
    }
    
    prevPage(){
        let cp = this.state.currentPage;
        if (cp === 1) return;
        this.setState({
          currentPage: cp - 1
        },() => {
          this.resultPage();
        });
    }
    
    nextPage(){
        let cp = this.state.currentPage;
        if (cp === this.state.pages) return;
        this.setState({
            currentPage: cp + 1
        },() => {
            this.resultPage();
        });
    }

    goToPage(page) {
        if(page === this.state.currentPage) return;
        this.setState({
            currentPage: page
        },() => {
            this.resultPage();
        });
    }

    openModal() {
        this.setState({
            showModalError: true
        })
    }

    closeModal() {
        this.setState({
            showModalError: false
        })
    }


    render() {

        const columns = [

            {
                Header: 'CODICE ESERCIZIO',
                accessor: 'branchCode',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'INSEGNA',
                accessor: 'name',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'DATA',
                accessor: 'date',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'RIFERIMENTO',
                accessor: 'summary',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'POS',
                accessor: 'pos',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'LORDO',
                accessor: 'amount',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'AUTORIZZAZIONE',
                accessor: 'autorization',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'NUMERO CARTA',
                accessor: 'pan',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'STATO',
                accessor: 'status',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                }
            },
            {
                Header: 'COMMISSIONI',
                accessor: 'commission',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },
            {
                Header: 'NETTO',
                accessor: 'net',
                headerClassName: 'sH',
                style: {
                    fontSize: '10px'
                },
                Cell: (row) => formatAmount(row.value)
            },

        ]

        let hasData = (Object.entries(this.state.dataHeader).length > 0 && this.state.dataHeader !== null && this.state.dataHeader !== undefined);
        
        
        return (
            <Box>
                {this.state.showTimeoutModal ? <ModalErrorTimeout /> : ''}
                {this.state.showModalError ? <ModalError type="excel" closeModal={this.closeModal}/> : ''}
                <Box align='center' className='content' style={{ backgroundColor: '#f9f9f9', marginTop: '0' }}>
                    <Box className='contentbox'>
                        <Box pad='medium' align='start' style={{ paddingBottom: '50px' }}>
                            <Text className='titlehome'><h1>Consulta Movimenti</h1></Text>
                            <Text className='subtitlehome'><h3>Seleziona i filtri di ricerca</h3></Text>
                        </Box>



                        <Box align='center' id='searchpv' justify='center'>
                            <Text className='titlesectionhome'><h3>PERIODO TEMPORALE</h3></Text>
                            <Box className='genericextMov' direction='row' gap='medium'>

                                <Box className='dropDownMovimenti'>
                                    <Text className='label'><h5>MESE E ANNO*</h5></Text>
                                    <AccessibleSelect 
                                        id='monthMov' 
                                        style={{marginRight:'13px'}} 
                                        className='select' 
                                        placeholder='Seleziona Mese' 
                                        options={this.state.months.map(month => ({
                                            label: month,
                                            value: month,
                                            'aria-label': month
                                        }))}
                                        labelKey='label'
                                        valueKey='value'
                                        value={this.state.selectedYearMonth ? {
                                            label: this.state.selectedYearMonth,
                                            value: this.state.selectedYearMonth,
                                            'aria-label': this.state.selectedYearMonth
                                        } : ''}
                                        onChange={this.setSelectionMonthYear} 
                                        a11yTitle='Mese e anno'
                                        dropAlign={{ top: 'bottom' }}
                                    />
                                </Box>
                                <Box className='dropDownMovimenti'>
                                    <Text className='label'><h5>GIORNO</h5></Text>
                                    <AccessibleSelect 
                                        id='day' 
                                        className='select' 
                                        placeholder='Seleziona Giorno' 
                                        disabled={this.state.disabledSDays} 
                                        options={this.state.optionsDay ? this.state.optionsDay.map(day => ({
                                            label: day,
                                            value: day,
                                            'aria-label': 'Giorno ' + day
                                        })) : []}
                                        labelKey='label'
                                        valueKey='value'
                                        value={this.state.selectedDay ? {
                                            label: this.state.selectedDay,
                                            value: this.state.selectedDay,
                                            'aria-label': 'Giorno ' + this.state.selectedDay
                                        } : ''}
                                        onChange={this.setSelectionDay} 
                                        a11yTitle='Giorno'
                                        dropAlign={{ top: 'bottom' }}
                                    />
                                </Box>

                            </Box>

                            <Text className='titlesectionhome' style={{marginTop:'24px'}}><h3>IMPORTO</h3></Text>
                            <Box className='genericextMov' direction='row' gap='medium'>
                                <Box>
                                    <Text className='label'><h5>MIN</h5></Text>
                                    <TextInput id='minamount' className='inputSearchpv' maxLength={13} value={this.state.minamount} placeholder='' onChange={this.setAmount} aria-label='Importo minimo' />
                                    <Text className='span'>,00</Text>
                                </Box>
                                <Box className='marginLeft'>
                                    <Text className='label'><h5>MAX</h5></Text>
                                    <TextInput id='maxamount' className='inputSearchpv' maxLength={13} value={this.state.maxamount} placeholder='' onChange={this.setAmount} aria-label='Importo massimo' />
                                    <Text className='span'>,00</Text>
                                </Box>
                            </Box>

                            <Text className='titlesectionhome'><h3>VALORE NETTO</h3></Text>
                            <Box className='genericextMov' direction='row' gap='medium'>
                                <Box>
                                    <Text className='label'><h5>MIN</h5></Text>
                                    <TextInput id='minamountnet' className='inputSearchpv' maxLength={13} value={this.state.minamountnet} placeholder='' onChange={this.setAmount} aria-label='Valore netto minimo' />
                                    <Text className='span'>,00</Text>
                                </Box>
                                <Box className='marginLeft'>
                                   <Text className='label'><h5>MAX</h5></Text>
                                    <TextInput id='maxamountnet' className='inputSearchpv' maxLength={13} value={this.state.maxamountnet} placeholder='' onChange={this.setAmount} aria-label='Valore netto massimo' />
                                    <Text className='span'>,00</Text>
                                </Box>
                            </Box>

                            <Box className='genericextMov' direction='row' gap='medium' style={{ marginTop: '20px' }}>
                                <Box>
                                    <Text className='label'><h5>Codice POS</h5></Text>
                                    <TextInput id='codpos' className='inputSearchpv' maxLength={10} value={this.state.codpos} placeholder='' onChange={this.setAmount} editable = {sessionStorage.getItem("codSocietario") === '0' ? true : false} aria-label='Codice POS' />
                                </Box>
                                <Box className='marginLeft'>
                                    <Text className='label'><h5>VISUALIZZA MOVIMENTI</h5></Text>
                                    <AccessibleSelect 
                                        id='movimenti' 
                                        className='select' 
                                        placeholder='Tutti' 
                                        options={this.state.data.optionsMov} 
                                        value={this.state.selectLabel} 
                                        onChange={this.setSelectionMovements} 
                                        a11yTitle='Visualizza movimenti'
                                        dropAlign={{ top: 'bottom' }}
                                    />
                                </Box>
                            </Box>
                            <Box className='genericextMov' style={{ marginTop: '30px' }}>
                                <Text className='suggestion'><p>*Campi obbligatori</p></Text>
                            </Box>
                            <Box style={{marginTop:'30px'}}>
                                <Button className={!this.state.selectedYearMonth ? 'btnsearchForm disabled' : 'btnsearchForm'} onClick={this.search} disabled={!this.state.selectedYearMonth}>
                                    <i className='icon-magnifying-glass' style={{ fontSize: '20px', fontStyle: 'normal' }}>CERCA</i>
                                </Button>
                            </Box>
                        </Box>

                        {hasData ?  
                                <div>
                                    <Box>
                                        <Box className='table' style={{ paddingTop: '50px', textAlign: 'left' }}>
                                            <Text className='searchResult'>RISULTATI DI RICERCA</Text>
                                        </Box>
                                        <InfoTable
                                            Title1='Cod Societario:'
                                            Title2='Punto Vendita:'
                                            Title3='Insegna:'
                                            Title4='Periodo:'
                                            Title5='Nr Movimenti:'
                                            Title6='Totale Lordo:'
                                            Title7='Totale Commissioni:'
                                            Title8='Totale Netto:'
                                            Result1={sessionStorage.getItem("codesoc")}
                                            Result2={sessionStorage.getItem('codepos') ? sessionStorage.getItem('codepos') : "Tutti"}
                                            Result3={sessionStorage.getItem("insegna")}
                                            Result4={this.state.selectedYearMonth}
                                            Result5={this.state.dataHeader.count}
                                            Result6={this.state.dataHeader.amount}
                                            Result7={this.state.dataHeader.commission}
                                            Result8={this.state.dataHeader.net}
                                            secondColumn={true}
                                        />
                                        <Box direction='row' style={{ padding: '0 2%' }}>
                                            <Box pad='large' style={{ width: '100%', padding: '0' }}>
                                                <ReactTable
                                                    data={this.state.dataTable}
                                                    columns={columns}
                                                    sortable={true}
                                                    multiSort={false}
                                                    resizable={true}
                                                    showPagination={false}
                                                    defaultPageSize={60}
                                                    style={{ paddingBottom: '20px' }}
                                                />
                                                <div>
                                                    <div style={{ height: '50px', display: 'flex-wrap', flexDirection: 'row' }}>
                                                        <button 
                                                            type="button"
                                                            aria-label="Pagina precedente"
                                                            style={{ width: '20px', height: '30px', color: this.state.currentPage === 1 ? '#999' : '#006fcf', cursor: this.state.currentPage === 1 ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                            onClick={() => {
                                                                this.prevPage();
                                                            }}
                                                            disabled={this.state.currentPage === 1}>
                                                            <i className='icon-left-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }}></i>
                                                        </button>
                                                        
                                                        <Text className='pag' style={{ fontSize: '12px', marginBottom: '12px' }}>{this.state.currentPage} di {this.state.pages}</Text>
                                                        
                                                        <button 
                                                            type="button"
                                                            aria-label="Pagina successiva"
                                                            style={{ width: '20px', color: this.state.currentPage === this.state.pages ? '#999' : '#006fcf', cursor: this.state.currentPage === this.state.pages ? 'not-allowed' : 'pointer', background: 'none', border: 'none', padding: 0 }}
                                                            onClick={() => {
                                                                this.nextPage();
                                                            }}
                                                            disabled={this.state.currentPage === this.state.pages}>
                                                            <i className='icon-right-chevron' style={{ fontSize: '12px', fontStyle: 'normal' }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </Box>
                                        </Box>
                                        <Box direction='row' className='footerTable rowColumn'>
                                            {this.state.loadingExcel ?
                                                loader
                                                :
                                                <Box className='contentXsls'>
                                                    <button type="button" className='excel' onClick={() => this.downloadExcel("C")} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                                                        <Text className='export'>ESPORTA<i className='icon-xlsx-file-format-extension' style={{ fontSize: '20px', marginLeft: '10px', verticalAlign: 'middle' }}></i></Text>
                                                    </button>
                                                </Box>
                                            }
                                            <ExcelFile filename='Movimenti' element={<span id='excel' style={{ display: 'none' }} />}>
                                                <ExcelSheet data={this.state.datas} name="Movimenti">
                                                        <ExcelColumn label="CODICE ESERCIZIO" value="branchCode" />
                                                        <ExcelColumn label="INSEGNA" value="name" />
                                                        <ExcelColumn label="DATA" value="date" />
                                                        <ExcelColumn label="RIFERIMENTO" value="summary" />
                                                        <ExcelColumn label="POS" value="pos" />
                                                        <ExcelColumn label="LORDO" value="amount" />
                                                        <ExcelColumn label="AUTORIZZAZIONE" value="autorization" />
                                                        <ExcelColumn label="NUMERO CARTA" value="pan" />
                                                        <ExcelColumn label="STATO" value="status" />
                                                        <ExcelColumn label="COMMISSIONE" value="commission" />
                                                        <ExcelColumn label="NETTO" value="net" />
                                                </ExcelSheet>
                                            </ExcelFile>
                                        </Box>
                                    </Box>
                                </ div>
                            : this.state.isRicerca ?
                                    loader
                            : null
                        }

                    </Box>

                </Box>

            </Box>
        )
    }
}
export default Movimenti;
